<template lang='pug'>
div(:class='$style[`cc-userPanel-board-container`]')
  div(:class='$style[`cc-userPanel-board-list`]')
    //- 查看個人檔案
    div(title='我的C幣' :class='$style[`cc-userPanel-board-nav-ccoin`]')
      div(v-if='!preLoading' :class='$style[`cc-userPanel-nav-wrap-ccoin`]')
        div(:class='$style[`cc-userPanel-nav-wrap-ccoin-right`]')
          span.border-gradient(v-if='subscribeVip === `yes`' :class='$style[`cc-userPanel-nav-wrap-ccoin-right-vip`]') VIP會員
          span(v-else :class='$style[`cc-userPanel-nav-wrap-ccoin-right-free`]') 基本會員

        div(:class='$style[`cc-userPanel-nav-wrap-ccoin-left`]')
          IconCcoin(:size='28')
          span.font-medium {{ `${score.point}幣` }}

      div(v-else :class='$style[`cc-userPanel-nav-wrap-ccoin`]')
        div.skeleton-preload(:class='$style[`cc-preloader-ccoin`]' style='height: 28px; width: 70%; border-radius: 25px;')

    router-link(
      v-if='loginProfile.user_type === `normal`'
      tag='button'
      tabindex='0'
      aria-label='交易紀錄'
      title='交易紀錄'
      :class='$style[`cc-userPanel-board-nav`]'
      :to='`/orders`')
      div(:class='$style[`cc-userPanel-nav-wrap`]')
        IconMoney(:size='20' :color='`#6f6f6f`')
        span 交易紀錄


    //- 追蹤我的人
    //- router-link(
    //-   v-if='loginProfile.user_type === `doctor`'
    //-   tag='button'
    //-   tabindex='0'
    //-   aria-label='追蹤我的人'
    //-   title='追蹤我的人'
    //-   :class='$style[`cc-userPanel-board-nav`]'
    //-   :to='{ name: `profile-follower`, params: { type: `${loginProfile.user_type}`, id: `${loginDjangoId}` } }')
    //-   div(:class='$style[`cc-userPanel-nav-wrap`]')
    //-     IconFollower(:size='20' :color='`#6f6f6f`')
    //-     span 追蹤我的人
    //-   //- IconFollower(:size='26' :color='`#6f6f6f`')
    //-   //- span!= '追蹤我的人'


    router-link(
      tag='button'
      tabindex='0'
      aria-label='問題回報'
      title='問題回報'
      :class='$style[`cc-userPanel-board-nav`]'
      to='/feedback')
      div(:class='$style[`cc-userPanel-nav-wrap`]')
        IconDialog(:size='20' :color='`#6f6f6f`')
        span 問題回報


    //- 我的病歷
    router-link(
      v-if='loginProfile.user_type === `normal`'
      tag='button'
      title='我的病歷'
      tabindex='0'
      aria-label='查看我的病歷'
      :class='$style[`cc-userPanel-board-nav`]'
      to='/ecard')
      div(:class='$style[`cc-userPanel-nav-wrap`]')
        IconData(:size='20' :color='`#6f6f6f`')
        span 我的病歷


    //- 查看個人檔案
    //- router-link(
    //-   tag='button'
    //-   title='會員檔案'
    //-   tabindex='0'
    //-   aria-label='查看會員檔案'
    //-   :class='$style[`cc-userPanel-board-nav`]'
    //-   :to='{ name: `profile-detail`, params: { type: `${loginProfile.user_type}`, id: `${loginDjangoId}` }}')
    //-   div(:class='$style[`cc-userPanel-nav-wrap`]')
    //-     IconData(:size='20' :color='`#6f6f6f`')
    //-     span 會員檔案
          //- span(style='font-size: 11px; margin-left: 3px;') ({{ loginDjangoId }})


    //- 查看個人檔案
    router-link(
      tag='button'
      title='帳戶設定'
      tabindex='0'
      aria-label='帳戶設定'
      :class='$style[`cc-userPanel-board-nav`]'
      to='/setting')
      div(:class='$style[`cc-userPanel-nav-wrap`]')
        IconSetting(:size='20' :color='`#6f6f6f`')
        span 帳戶設定
          span(style='font-size: 11px; margin-left: 3px;') ({{ loginDjangoId }})


    //- 查看個人檔案
    //- a(
    //-   v-else
    //-   tag='div'
    //-   title='會員資料'
    //-   :class='$style[`cc-userPanel-board-nav`]'
    //-   :href='`${NODE_DOMAIN}/doctor/${loginDjangoId}`')
    //-   div(:class='$style[`cc-userPanel-nav-wrap`]')
    //-     IconData(:size='20' :color='`#6f6f6f`')
    //-     span!= '會員檔案'

    //- 會員登出
    button(
      title='登出'
      tabindex='0'
      aria-label='登出'
      :class='$style[`cc-userPanel-board-nav`]'
      @click='handleClickLogOut')
      div(:class='$style[`cc-userPanel-nav-wrap`]')
        IconLogOut(:size='20' :color='`#6f6f6f`')
        span 登出


  div(:class='$style[`cc-userPanel-board-cancell`]')

    //- 查看個人檔案
    router-link(
      tag='button'
      title='關於Cancell'
      tabindex='0'
      aria-label='關於Cancell'
      :class='$style[`cc-userPanel-board-nav`]'
      :to='`/about`')
      div(:class='$style[`cc-userPanel-nav-wrap`]')
        span 關於Cancell

    //- 查看個人檔案
    //- router-link(
    //-   tag='button'
    //-   title='問題回報'
    //-   tabindex='0'
    //-   aria-label='問題回報'
    //-   :class='$style[`cc-userPanel-board-nav`]'
    //-   :to='`/feedback`')
    //-   div(:class='$style[`cc-userPanel-nav-wrap`]')
    //-     span!= '問題回報'

    //- 查看功能導覽
    //- router-link(
    //-   tag='button'
    //-   title='功能導覽'
    //-   tabindex='0'
    //-   aria-label='功能導覽'
    //-   :class='$style[`cc-userPanel-board-nav`]'
    //-   :to='`/tutorial`')
    //-   div(:class='$style[`cc-userPanel-nav-wrap`]')
    //-     span 功能導覽

    //- a(
    //-   title='贊助我們'
    //-   :href='`https://www.zeczec.com/projects/cancell?r=8b18c85c81`'
    //-   :class='$style[`cc-userPanel-board-nav`]')
    //-   div(:class='$style[`cc-userPanel-nav-wrap`]')
    //-     span!= '贊助我們'

    //- 查看個人檔案
    router-link(
      tag='button'
      title='隱私權、個資保護聲明'
      tabindex='0'
      aria-label='隱私權、個資保護聲明'
      :class='$style[`cc-userPanel-board-nav`]'
      :to='`/privacy`')
      div(:class='$style[`cc-userPanel-nav-wrap`]')
        span 隱私權、個資保護聲明

    //- 查看個人檔案
    router-link(
      tag='button'
      title='使用條款'
      tabindex='0'
      aria-label='使用條款'
      :class='$style[`cc-userPanel-board-nav`]'
      :to='`/term`')
      div(:class='$style[`cc-userPanel-nav-wrap`]')
        span 使用條款

  div(:class='$style[`cc-userPanel-copyright`]')
    span(:class='$style[`cc-userPanel-copyright-text`]') Cancell © 2025

</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
// import GlobalEmitter from 'tiny-emitter/instance';
// import * as jwt_decode from 'jwt-decode';
import IconData from '../../icon/Data';
import IconSetting from '../../icon/Setting';
import IconLogOut from '../../icon/LogOut';
import IconCcoin from '../../icon/Ccoin';
import IconMoney from '../../icon/Money';
import IconDialog from '../../icon/Dialog';
import IconFollower from '../../icon/Follower';

// import IconDonate from '../../icon/Donate';

import {
  getUserScore,
  deleteSessionKeepLogin,
} from '../../../js/restapi';

export default {
  components: {
    IconData,
    IconSetting,
    IconLogOut,
    IconCcoin,
    IconMoney,
    IconDialog,
    IconFollower,
    // IconDonate,
  },

  data() {
    return {
      preLoading: true,
      score: {
        hp: 0,
        point: 0,
      },
    };
  },

  created() {
    this.axiosLoadUserScore();
  },

  methods: {
    ...mapActions({
      changeLoginStatus: 'user/userLoginMember',
      changeUserPanel: 'user/changeTopBarUserPanelFocus',
    }),

    ...mapMutations({
      changeAuthJwtToken: 'user/USER_AUTH_JWT',
      changePopBoxStatus: 'global/POPBOX_STATUS',
    }),

    axiosLoadUserScore() {
      getUserScore('', {})
        .then((res) => {
          this.score = res.data;
          this.preLoading = false;
          console.log('score', this.score);
        })
        .catch(() => {});
    },

    handleClickLogOut() {
      this.changePopBoxStatus({
        active: true,
        include: 'loading',
      });

      deleteSessionKeepLogin(`/${this.loginHashCode}`)
        .then((/* response */) => {
          console.log('成功登出，並刪除Session');
          localStorage.removeItem('cc-jwt');

          const logOutProcess = new Promise((resolve) => {
            this.changeAuthJwtToken(null);
            this.changeUserPanel(false);
            this.changeLoginStatus({
              isLogin: false,
              djangoId: null,
              hashCode: '',
              profile: {},
            });
            return resolve('done');
          });

          logOutProcess.then((value) => {
            if (value === 'done') {
              this.$router.replace({
                name: 'index',
              }).catch(() => {});

              setTimeout(() => {
                this.changeLoginStatus({
                  isLogin: false,
                  djangoId: null,
                  hashCode: '',
                  profile: {},
                });

                this.changePopBoxStatus({
                  active: false,
                  include: '',
                });
              }, 800);
            }
          });

          // window.location.reload();
        })
        .catch((/* error */) => {
          console.log('刪除Session 出包!');
          this.changePopBoxStatus({
            active: false,
            include: '',
          });
        });
      // if (this.$route.path !== '/') {
      //   this.$router.push({ name: 'index'}).catch(() => true);
      // }
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      authJwtToken: 'user/exportUserJwtToken',
      loginProfile: 'user/exportUserProfile',
      loginDjangoId: 'user/exportUserDjangoId',
      loginHashCode: 'user/exportUserHashCode',
      subscribeVip: 'user/exportUserSubscribeVip',
    }),
  },
};

</script>

<style module lang='scss'>
   @import '../../../sass/component/page/topbar/boardUserPanel.scss';
</style>
